import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { map } from "leaflet";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-device-stock",
  templateUrl: "./device-stock.component.html",
  styleUrls: ["./device-stock.component.scss"],
})
export class DeviceStockComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService // private modalService: NzModalService, // private notification: NzNotificationService
  ) {}
  searchTerm;
  listData = [];
  selectedFile: File | null = null;
  pageSize = 10;
  pageIndex = 1;
  totalCount = 0;
  tableName = "device-stock";
  role = JSON.parse(localStorage.getItem("currentUser"))["role"];

  get canManageStock(): boolean {
    return this.role === "admin" || this.role === "delivery";
  }
  submitted: boolean;
  formData: FormGroup;
  listModel = [];
  listVersion = ["Paybox", "Soundbox"];
  listWs = [];
  // listStatus = ['Trực tuyến' , 'Ngoại tuyến']
  breadCrumbItems;
  params = "";
  filter = {
    serial_number: "",
    sim4g_imsi: "",
    status: "",
    device_type_id: "",
  };
  searching = false;
  deviceLinkHistory: any[] = [];
  deviceLinkHistorySerial = "";

  network_provider = [
    { value: "Mobifone", label: "Mobifone" },
    { value: "Viettel", label: "Viettel" },
    { value: "Vinaphone", label: "Vinaphone" },
  ];
  listDevicesFilter = [];

  owner = [
    { value: "TMT", label: "TMT" },
    { value: "DD", label: "DD" },
  ];

  get form() {
    return this.formData.controls;
  }

  ngOnInit() {
    this.breadCrumbItems = [
      { label: "PAGE.HOME" },
      { label: "PAGE.REPORT.IncidentType", active: true },
    ];
    this.fetchData();
    this.getDeviceTypes();
  }
  getDeviceModels(deviceTypeId: any) {
    if (!deviceTypeId) {
      this.listModel = [];
      return;
    }

    this.apiService
      .getList(`service-packages/model?deviceTypeId=${deviceTypeId}`)
      .subscribe({
        next: (res: any) => {
          this.listModel =
            res?.metadata?.results?.map((model: any) => ({
              value: model,
              label: model,
            })) || [];
        },
        error: () => {
          this.listModel = [];
        },
      });
  }
  getDeviceTypes() {
    this.apiService.getList("device-types").subscribe({
      next: (res) => {
        this.listDevicesFilter =
          res?.metadata?.results?.map((item: any) => ({
            value: item.id,
            label: item.name,
          })) || [];
      },
      error: (err) => console.error("Error loading device types", err),
    });
  }
  submitFilter() {
    this.params = "";
    Object.keys(this.filter).forEach((key) => {
      console.log(key + "-" + this.filter[key]);
      if (this.filter[key]) {
        this.params += `&${key}=${this.filter[key]}`;
      }
    });
    if (this.params) {
      this.pageIndex = 1;
      this.searching = true;
      this.fetchData();
    }
  }

  clearFilter() {
    this.params = "";
    this.filter.serial_number = "";
    this.filter.sim4g_imsi = "";
    this.filter.device_type_id = "";
    this.filter.status = "";
    this.pageIndex = 1;
    this.fetchData();
  }

  getDataWs() {
    this.eventService.setLoading(true);
    this.apiService.getList("workspaces").subscribe({
      next: (res) => {
        this.listWs = res?.workspaces ? res?.workspaces : [];
        this.eventService.setLoading(false);
      },
      error: (err) => {
        console.error(err);
        this.eventService.setLoading(false);
      },
    });
  }
  onChangePage(e) {
    this.pageIndex = e;
    this.fetchData();
  }

  fetchData(params = "") {
    params = `&order=updated_at&direction=desc${this.params}`;
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        this.tableName +
          `?page=${this.pageIndex}&limit=${this.pageSize}${params}`
      )
      .subscribe({
        next: (res) => {
          this.listData = res.metadata["deviceStocks"]
            ? res.metadata["deviceStocks"]
            : [];
          this.totalCount = res.metadata.pagination.totalCount
            ? res.metadata.pagination.totalCount
            : "";
          this.eventService.setLoading(false);
        },
      });
  }

  getDeviceUsageStatus(hasBeenUsed: any): string {
    if (Number(hasBeenUsed) === 1) {
      return "Đã từng sử dụng";
    }
    if (Number(hasBeenUsed) === 0) {
      return "Chưa từng sử dụng";
    }
    return "";
  }

  getReuseCategoryLabel(reuseCategory: string): string {
    const labels = {
      REUSABLE: "Có thể tái sử dụng",
      WARRANTY_ONLY: "Chỉ sử dụng để bảo hành",
    };
    return labels[reuseCategory] || "";
  }

  getOriginOrderTypeLabel(originOrderType: string): string {
    const labels = {
      NORMAL: "Đơn thường",
      GIVEAWAY: "Đơn tặng loa",
    };
    return labels[originOrderType] || "";
  }

  showDeviceLinkHistory(device: any, content: any): void {
    const serialNumber = device?.serial_number;
    if (!serialNumber) {
      return;
    }

    this.deviceLinkHistory = [];
    this.deviceLinkHistorySerial = serialNumber;
    this.eventService.setLoading(true);
    this.apiService
      .getList(`device-stocks/${encodeURIComponent(serialNumber)}/link-history`)
      .subscribe({
        next: (res: any) => {
          this.deviceLinkHistory = res?.metadata?.history || [];
          this.eventService.setLoading(false);
          this.modalService.open(content, {
            centered: true,
            scrollable: true,
            size: "xl",
          });
        },
        error: (error) => {
          console.error("Không thể tải lịch sử liên kết thiết bị", error);
          this.apiService.showToastMobile(
            "error",
            error?.error?.message || "Không thể tải lịch sử liên kết thiết bị"
          );
          this.eventService.setLoading(false);
        },
      });
  }

  deviceLink(data) {
    if (!this.canManageStock) {
      return;
    }
    console.log(data);

    this.apiService
      .postItem("workspaces/link-device/" + data.version, { deviceId: data.id })
      .subscribe({
        next: (res) => {
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Liên kết thành công")
          );
        },
        error: (e) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Liên kết thất bại")
          );
          this.eventService.setLoading(false);
        },
      });
  }
  excelData: any;

  onFileChange(event: any) {
    if (!this.canManageStock) {
      return;
    }
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  // Gửi file lên server
  uploadFile(value) {
    if (!this.canManageStock) {
      return;
    }
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append("file", this.selectedFile, this.selectedFile.name);
      for (const key in value) {
        if (value.hasOwnProperty(key)) {
          formData.append(key, value[key]);
        }
      }

      this.http.post("device-stocks/import-file", formData).subscribe(
        (response) => {
          this.apiService.showToast(
            this.translateService.instant("FORM.Success"),
            this.translateService.instant(response["metadata"]["message"]),
            "success"
          );
          this.fetchData();
          this.modalService.dismissAll();
        },
        (error) => {
          this.apiService.showToast(
            this.translateService.instant("FORM.Error"),
            this.translateService.instant(error),
            "error"
          );
        }
      );
    } else {
      this.apiService.showToast(
        this.translateService.instant("FORM.Error"),
        this.translateService.instant("Không tìm thấy file"),
        "error"
      );
      console.error("No file selected");
    }
  }

  openModal(content: any) {
    if (!this.canManageStock) {
      return;
    }
    this.submitted = false;
    this.formData = this.makeForm({ language: [{}] });
    let a = this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }

  onEdit(data, content) {
    if (!this.canManageStock) {
      return;
    }
    console.log(data);
    this.formData = this.makeForm(data);
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }
  onLink(data, content) {
    if (!this.canManageStock) {
      return;
    }
    console.log(data);
    this.formData = this.makeForm(data);
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  selectedIncident = null;
  selectedKeyword = null;

  makeFormKeyword(d) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      id: [data.id],
      name: [data.name],
      incident_type_id: [data.incident_type_id],
    });
  }

  fetchKeyword() {
    this.dataKeyword = [];
    this.eventService.setLoading(true);
    this.apiService
      .getList(`keyword?type_id=${this.selectedIncident.id}`)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.dataKeyword = [...res];
          this.eventService.setLoading(false);
        },
      });
  }

  dataKeyword = [];

  formEditKeyword: FormGroup;
  formNewKeyword: FormGroup;
  editKeyword(data, index) {
    this.formEditKeyword = this.makeFormKeyword(data);
    this.selectedKeyword = data;
  }

  onSubmitFormKeyword(type) {
    if (type == 1) {
      if (this.formEditKeyword.valid) {
        const value = this.formEditKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.editItem("keyword", value.id, value).subscribe({
          next: (res) => {
            this.selectedKeyword = null;
            this.fetchKeyword();
            this.eventService.setLoading(false);
          },
        });
      }
    } else {
      if (this.formNewKeyword.valid) {
        const value = this.formNewKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.addItem("keyword", value).subscribe({
          next: (res) => {
            this.eventService.setLoading(false);
            this.formNewKeyword.reset({
              incident_type_id: this.selectedIncident.id,
            });
            this.fetchKeyword();
          },
        });
      }
    }
  }

  onOpenKeywordModal(content, incident) {
    this.selectedIncident = incident;
    this.fetchKeyword();
    this.formNewKeyword = this.makeFormKeyword({
      incident_type_id: this.selectedIncident.id,
    });
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  defaultPrices = [
    { condition: 1, price: 0, unit: "" },
    { condition: 2, price: 0, unit: "" },
  ];

  onDeleteKeyword(id) {
    if (id) {
      this.eventService.setLoading(true);
      this.apiService.deleteItem("keyword", id).subscribe((res) => {
        Swal.fire(
          this.translateService.instant("FORM.Success"),
          this.translateService.instant("FORM.SuccessMessageDelete"),
          "success"
        ).then((res) => {
          this.fetchKeyword();
        });
        this.eventService.setLoading(false);
      });
    }
  }

  onDelete(data) {
    if (!this.canManageStock) {
      return;
    }
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant("FORM.WarningMessage"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.value) {
        this.apiService.deleteItem(this.tableName, data).subscribe((res) =>
          Swal.fire(
            this.translateService.instant("FORM.Success"),
            this.translateService.instant("FORM.SuccessMessageDelete"),
            "success"
          ).then((res) => {
            this.fetchData();
          })
        );
      }
    });
  }

  makeForm(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      network_provider: [data.network_provider || null, [Validators.required]],
      deviceTypeId: [data.deviceTypeId || null, [Validators.required]],
      type: [data.type || null, [Validators.required]],
    });
  }

  makePrices(data = []) {
    let arr = new FormArray([]);
    data.forEach((i) => {
      arr.push(this.makePrice(i));
    });
    return arr;
  }

  makePrice(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      key: [data.key, [Validators.required]],
      // price: [data.price, [Validators.required, Validators.min(0)]],
      value: [data.value, [Validators.required]],
      // id: [data.id]
    });
  }

  uploadedImage;

  saveData() {
    if (!this.canManageStock) {
      return;
    }
    this.submitted = true;
    if (this.formData.valid) {
      const value = this.formData.value;
      this.eventService.setLoading(true);
      if (value.id) {
        this.apiService.editItem(this.tableName, value.id, value).subscribe({
          next: (res) => {
            this.submitted = false;
            this.formData.reset();
            this.fetchData();
            this.modalService.dismissAll();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessage"),
              "success"
            );
            this.eventService.setLoading(false);
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessage"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      } else {
        this.uploadFile(value);
        this.eventService.setLoading(false);
        // this.apiService.addItem(this.tableName, value).subscribe({
        //   next: res => {
        //     this.fetchData()
        //     this.apiService.showToast(this.translateService.instant('FORM.Success'), this.translateService.instant('FORM.SuccessMessageAdd'), 'success')
        //     this.eventService.setLoading(false)
        //     this.modalService.dismissAll()
        //   },
        //   error: e => {
        //     this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant('FORM.ErrorMessageAdd'), 'error')
        //     this.eventService.setLoading(false)
        //   }
        // })
      }
    } else {
      console.log("invalid", this.formData);
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status == "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  goToPreviousPage() {
    if (this.pageIndex > 1) {
      this.pageIndex--;
      this.fetchData();
    }
  }

  goToNextPage() {
    if (this.pageIndex < this.totalCount) {
      this.pageIndex++;
      this.fetchData();
    }
  }
}
